<template>
<v-container>
  <v-card>
    <v-card-text>
      <v-select
        label="Processo Seletivo"
        clearable
        :items="processosSeletivos"
        item-text="descricao"
        item-value="id"
        v-model="filtro.ps"
      ></v-select>
      <v-select
        label="Chamada"
        clearable
        :items="chamadasByPS"
        item-text="titulo"
        item-value="id"
        v-model="filtro.chamada"
        @change="loadCampus"
      ></v-select>
      <v-select
        label="Campus"
        clearable
        :items="listaDeCampi"
        item-text="nomeCampus"
        item-value="id"
        v-model="filtro.campus"
        @change="loadCursosDoCampus"
      ></v-select>              
      <v-select
        label="Curso"
        clearable
        :items="listaDeCursos"
        item-text="nomeCurso"
        item-value="id"
        v-model="filtro.curso"
      ></v-select>
      <v-checkbox
        label="Somente pendentes de análise"
        v-model="filtro.somentePendentes"
      ></v-checkbox>
      <v-checkbox
        label="Somente candidatos não registrados"
        v-model="filtro.somenteNaoRegistrados"
      ></v-checkbox>
      <v-divider></v-divider>
      <v-btn class="mt-3" @click="loadCandidatos" color="primary"
        >Buscar</v-btn
      >
      <v-text-field
        v-model="searchCandidato"
        append-icon="mdi-magnify"
        label="Filtrar"
        single-line
        hide-details
      ></v-text-field>
      <v-data-table
        dense
        :items="candidatos"
        :headers="colunas"
        :search="searchCandidato"
        :loading="isLoadingCandidatos"
        :item-class="corLinhaCandidato"
        multi-sort
      >
          <template v-slot:[`item.actions`]="{ item }" v-if="!listagemPublica">
          <v-btn
            icon
            v-if="item.prematricula.id"
            @click="editarPrematricula(item)"
          >
            <v-icon color="primary"> mdi-information </v-icon>
          </v-btn>
        </template>
        <template v-slot:[`item.prematricula.statusRegistroMatricula.descricao`] ="{ item }">
          <div> {{ getStatusRegistro(item) }}</div>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>  
</v-container>
</template>


<script>
import * as CampusService from "@/services/campus.service";
import * as CandidatoService from "@/services/candidato.service";
import { mapGetters } from 'vuex';

export default {
  components: {},
  props: {
    listagemPublica: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      listaDeCampi: [],
      listaDeCursos: [],
      isLoadingCandidatos: false,
      searchCandidato: "",
      filtro: {
        campus: "",
        curso: "",
        chamada: "",
        ps: "",        
        somentePendentes: true,
        somenteNaoRegistrados: false,
      },
    }
  },
  mounted() {
    this.loadProcessosSeletivos()
    this.loadChamadas()
  },
  methods : {
    editarPrematricula(item){
      this.$emit('editarPrematricula', item);
    },
    loadProcessosSeletivos() {
      this.isLoadingPS = true;
      if (this.listagemPublica){
        this.$store.dispatch('processosSeletivos/loadPublico')
        .catch(() => this.$msg.error('Erro ao carregar a lista de Processos Seletivos!'))
        .finally(() => (this.isLoadingPS = false));
      }else{
      this.$store.dispatch('processosSeletivos/load')
        .catch(() => this.$msg.error('Erro ao carregar a lista de Processos Seletivos!'))
        .finally(() => (this.isLoadingPS = false));
      }
    },
    loadChamadas() {
      this.isLoadingChamadas = true;
      this.$store.dispatch('chamadas/load')
        .catch(() => this.$msg.error('Erro ao carregar as chamadas!'))
        .finally(() => (this.isLoadingChamadas = false));
    },
    loadCampus() {
      this.listaDeCursos = [];
      this.listaDeCampi = [];
      this.filtro.campus = null;
      this.filtro.curso = null;
      if (this.filtro.chamada){
        this.$nprogress.start();
        CampusService.getAllByChamada(this.filtro.chamada)
          .then((res) => (this.listaDeCampi = res.data))
          .finally(() => this.$nprogress.done());
      }
    },  
    loadCursosDoCampus() {
      if (this.filtro.campus !== null) {
        this.isLoadingCursos = true;
        CampusService.getAllCursosByChamadaCampus(
          this.filtro.chamada,
          this.filtro.campus
        )
          .then((res) => (this.listaDeCursos = res.data))
          .finally(() => (this.isLoadingCursos = false));
      } else {
        this.listaDeCursos = [];
        this.filtro.curso = null;
      }
    },  
    loadCandidatos() {
      this.isLoadingCandidatos = true;
      if (this.listagemPublica === true){
        CandidatoService.getAllPublico(this.filtro)
          .then((res) => (this.$store.commit('candidatos/LOAD_CANDIDATOS', res.data)))
          .finally(() => (this.isLoadingCandidatos = false));
      }else{
        CandidatoService.getAll(this.filtro)
          .then((res) => (this.$store.commit('candidatos/LOAD_CANDIDATOS', res.data)))
          .finally(() => (this.isLoadingCandidatos = false));
      }
    },
    corLinhaCandidato(item) {
      //cores definidas em vuetify.js
      var codigo = item.prematricula.statusFinal.codigo;
      var reg = item.prematricula.statusRegistroMatricula.codigo
      if (codigo == 'RASCUNHO')
        return 'AZUL';
      if (codigo == 'NAO_INICIADA')
        return 'CINZA';
      if (codigo == 'COM_PENDENCIAS')
        return 'ROXO';
      if (codigo == 'AGUARDA_ANALISE')
        return 'AMARELO';
      if (codigo == 'REJEITADA')
        return 'VERMELHO';
      if (codigo == 'APROVADA'){
        if (reg == 'CANDIDATO_NAO_REGISTRADO')
          return 'AMARELO';
        if (reg == 'CANDIDATO_MATRICULADO')
          return 'VERDE';
        if (reg == 'CANDIDATO_NAO_MATRICULADO')
          return 'VERMELHO';
        if (reg == 'DESISTENCIA_A_PEDIDO')
          return 'VERMELHO';
        if (reg == 'ESTUDANTE_ELIMINADO')
          return 'VERMELHO';
        if (reg == 'CHAMADA_ANTIGA')
          return 'VERDE';
      }
      
      return 'BRANCO';
    },
    getStatusRegistro(item){
      if (item.prematricula.statusFinal.codigo === 'APROVADA'){
        if (item.prematricula.statusRegistroMatricula.codigo === 'DESISTENCIA_A_PEDIDO')
          return 'Matrícula Excluída';
        if (item.prematricula.statusRegistroMatricula.codigo === 'ESTUDANTE_ELIMINADO')
          return 'Matrícula Excluída';
        
        return item.prematricula.statusRegistroMatricula.descricao;
      }  
      return '';
    }
  },
  computed: {
    ...mapGetters({
      'chamadas':'chamadas/chamadasByPS',
      'processosSeletivos': 'processosSeletivos/list',
      'candidatos': 'candidatos/list'
    }),
    chamadasByPS(){
      return this.chamadas(this.filtro.ps)
    },
    colunas(){
      let colunas = [
        {
          text: "Nome",
          align: "start",
          sortable: true,
          value: "nome",
          width: "",
        },
        {
          text: "Curso",
          align: "start",
          sortable: true,
          value: "curso",
          width: "",
        },
        {
          text: "Campus",
          align: "start",
          sortable: true,
          value: "campus",
          width: "",
        },
        {
          text: "Classificação",
          align: "center",
          sortable: true,
          value: "classificacao",
          width: "",
        },
        {
          text: "Modalidade",
          align: "start",
          sortable: true,
          value: "modalidade",
          width: "",
        },
        {
          text: "Documental",
          align: "center",
          sortable: true,
          value: "prematricula.analiseDocumentacao",
          width: "",
        },
        {
          text: "Renda",
          align: "center",
          sortable: true,
          value: "prematricula.analiseRenda",
          width: "",
        },
        {
          text: "PPI",
          align: "center",
          sortable: true,
          value: "prematricula.analiseRaca",
          width: "",
        },
        {
          text: "PcD",
          align: "center",
          sortable: true,
          value: "prematricula.analisePcD",
          width: "",
        },
        {
          text: "Status Geral da Análise",
          align: "start",
          sortable: true,
          value: "prematricula.statusFinal.descricao",          
          width: "",
        },
        {
          text: "Status do Registro da Matrícula",
          align: "start",
          sortable: true,     
          value: "prematricula.statusRegistroMatricula.descricao",  
          width: "",
        }
      ];
      if (!this.listagemPublica){
        colunas.push({ text: "Análise", value: "actions", sortable: false, align: "center" });
      }
      return colunas;
    }
  }
};
</script>

    


